import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bbeffa90"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'Honor'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const honorRef = ref(null); // 荣耀表单ref
    const divideList2 = ref([]); // 分成比例
    const honorForm = reactive({
      pkg: '',
      appId: '',
      appSecret: '',
      publishKey: '',
      clientId: '',
      divide: '',
      id: ''
    });
    const validateForm = () => {
      var _honorRef$value;
      (_honorRef$value = honorRef.value) === null || _honorRef$value === void 0 || _honorRef$value.validate().then(() => {
        emit('submitForm', honorForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        var _n$rateList;
        honorForm.pkg = n.pkg;
        honorForm.appId = n.appId;
        honorForm.appSecret = n.appSecret;
        honorForm.publishKey = n.publishKey;
        honorForm.clientId = n.clientId;
        honorForm.divide = n.divide;
        divideList2.value = (_n$rateList = n.rateList) !== null && _n$rateList !== void 0 ? _n$rateList : [];
        honorForm.id = n.id;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: honorForm,
        ref_key: "honorRef",
        ref: honorRef,
        rules: __props.rules,
        name: "honor-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: honorForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => honorForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "APPID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: honorForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => honorForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "appSecret："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: honorForm.appSecret,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => honorForm.appSecret = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "IAP公钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: honorForm.publishKey,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => honorForm.publishKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "clientId："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: honorForm.clientId,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => honorForm.clientId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成比例："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: honorForm.divide,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => honorForm.divide = $event),
            options: divideList2.value,
            placeholder: "请选择分成比例"
          }, null, 8, ["value", "options"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});